import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import CountrySelect from './CountryFilter';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import { FilterPanel, StatusChip } from '../../Visual';

export interface CompanyCodesFiltersProps {
  actions: ReactNode;
  applyDisabled: boolean;
  countryRequiredIncomplete: boolean;
}

const CompanyCodesFilters = ({
  actions,
  applyDisabled,
  countryRequiredIncomplete,
}: CompanyCodesFiltersProps) => {
  const { t } = useTranslation();

  return (
    <PermissionsProvider resourcePermissions={[AppPermissions.COMPANY_CODES_QUERY]}>
      <FilterPanel
        subtitleTranslationKey="companyCodes.filters.subtitle"
        actions={
          <StatusChip
            status={applyDisabled ? 'warning' : 'success'}
            label={applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')}
          />
        }
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <CountrySelect fullWidth requiredIncomplete={countryRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default CompanyCodesFilters;
